import React from "react";

const TransitionModule = ({ payload }) => {
	return <>{payload}</>;
};

export default TransitionModule;
